import { Cover, UserNoDates } from "@/types/types";
import { isValidLengthSubscription } from "@/utils/subscriptionLevels/time/isValidLengthSubscription";

export const handleCoverSelect = (
  cover: Cover,
  user: UserNoDates | null,
  setAuthModalOpen: () => void,
  checkSubscription: boolean,
  setInvalidLengthSubscriptionModalOpen: (value: boolean) => void,
  audioLengthMinLimitMinutes: number | null,
  audioLengthMaxLimitMinutes: number,
  setInvalidLengthMaxModalOpen: (value: boolean) => void,
  setInputCover: (newInputCover: Cover) => void,
  showCover: boolean
) => {
  if (user === null) {
    setAuthModalOpen();
    return;
  }

  const audioLength = cover.audioLength;

  if (checkSubscription) {
    const validSubscription = isValidLengthSubscription(
      user.conversionTimeLeftSeconds,
      audioLength
    );

    if (!validSubscription) {
      setInvalidLengthSubscriptionModalOpen(true);
      return;
    }
  }

  const validMin =
    audioLengthMinLimitMinutes === null ||
    audioLength >= audioLengthMinLimitMinutes * 60;
  const validMax = audioLength <= audioLengthMaxLimitMinutes * 60;

  if (!validMin || !validMax) {
    setInvalidLengthMaxModalOpen(true);
    return;
  }

  if (showCover) {
    setInputCover(cover);
  }
};
